import { forwardRef, type AnchorHTMLAttributes, type MouseEvent } from "react";
import { useRotatingCTA } from "@/hooks/useRotatingCTA";

/**
 * Country deep-link to the ERP public demo booking page (`/book/demo`).
 * The marketing site never computes slots — it only hands the browser to
 * `app.bidmio.{tld}` matching the current locale.
 */
export type BookDemoAnchorProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  source: string;
};

export const BookDemoAnchor = forwardRef<HTMLAnchorElement, BookDemoAnchorProps>(
  function BookDemoAnchor({ source, onClick, target, rel, children, ...rest }, ref) {
    const { getBookDemoUrl, handleBookDemoClick } = useRotatingCTA();
    const track = handleBookDemoClick(source);
    return (
      <a
        {...rest}
        ref={ref}
        href={getBookDemoUrl()}
        target={target ?? "_blank"}
        rel={rel ?? "noopener noreferrer"}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
          track(event);
          onClick?.(event);
        }}
      >
        {children}
      </a>
    );
  },
);
BookDemoAnchor.displayName = "BookDemoAnchor";
